import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'

const descreverPergunta = pergunta => {
    const tipo = pergunta.tipo_pergunta && pergunta.tipo_pergunta.label
    const opcoes = (pergunta.opcoes || []).map(opcao => opcao.descricao).join(', ')
    const negativo = pergunta.mostrar_nao_possui ? ' · exibe "Negativo"' : ''

    return `${tipo}${opcoes ? ': ' + opcoes : ''}${negativo}`
}

const Visualizacao = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        if (id) {
            visualizar('/preanestesico/formulario', id,
                obj =>
                    setDados(obj.id ? {
                        id,
                        modulo: props.modulo,
                        titulo: `Visualização do Formulário - ${obj.descricao}`,
                        grupos: [
                            {
                                titulo: 'Dados Gerais',
                                colunas: [
                                    { titulo: 'Código', descricao: obj.id, tamanho: 'col-lg-3' },
                                    { titulo: 'Formulário', descricao: obj.descricao, tamanho: 'col-lg-5' },
                                    { titulo: 'Grupos / Perguntas', descricao: `${(obj.grupos || []).length} / ${(obj.grupos || []).reduce((total, grupo) => total + (grupo.perguntas || []).length, 0)}`, tamanho: 'col-lg-4' }
                                ]
                            },
                            ...(obj.grupos || []).map(grupo => ({
                                titulo: `${grupo.ordem}. ${grupo.descricao}`,
                                colunas: (grupo.perguntas || []).length > 0
                                    ? grupo.perguntas.map(pergunta => ({ titulo: `${pergunta.ordem}. ${pergunta.descricao}`, descricao: descreverPergunta(pergunta), tamanho: 'col-lg-6' }))
                                    : [{ titulo: 'Perguntas', descricao: 'Nenhuma pergunta neste grupo.', tamanho: 'col-lg-12' }]
                            }))
                        ]
                    } : { titulo: 'Visualização do Formulário' })
            )
        }
    }, [id])

    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}

export default Visualizacao
